var _rect, _rect2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAdaptabilityyPrinciple(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 14,
    y: 14,
    width: 26,
    height: 26,
    fill: "white",
    fillOpacity: 0.45
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    fill: "white",
    fillOpacity: 0.3
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdaptabilityyPrinciple);
export default __webpack_public_path__ + "static/media/adaptabilityy-principle.421a1b7dd327889cd3502e1ce69cd252.svg";
export { ForwardRef as ReactComponent };